// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, takeUntil } from 'rxjs';
import { Select, Store } from '@ngxs/store';

// Models
import { DynamicTableColumn, DynamicTableType } from '../../../../../../shared/models/dynamic-table-column.model';
import { DashboardDto } from '../../models/dashboard-dto';
import { AppCleanup } from '../../../../../../shared/models';

// Store
import { DashboardState } from '../../state/dashboard.state';
import { DashboardActions } from '../../state/dashboard.action';

// Helpers
import { UtilityHelper } from '../../../../../../shared/helpers';

@Component({
	selector: 'select-dashboard-dialog',
	templateUrl: './select-dashboard-dialog.component.html',
	styleUrls: ['./select-dashboard-dialog.component.scss'],
})
export class SelectDashboardDialogComponent extends AppCleanup implements OnInit, OnDestroy {
	componentTitle: string = 'Select dashboard';
	@Select(DashboardState.isLoaded) isLoaded$: Observable<boolean>;
	@Select(DashboardState.dashboards) dashboards$: Observable<DashboardDto[]>;
	jobKey: string;
	userDashboards: DashboardDto[] = [];
	selectedUserDashboard: DashboardDto;

	columnList: DynamicTableColumn[] = [
		{
			name: 'name',
			display: 'Name',
			disableSorting: true,
			width: 3,
		},
		{
			name: 'isGlobal',
			display: 'Global',
			disableSorting: true,
			width: 1,
		},
		{
			name: 'dashboardItems',
			type: DynamicTableType.COUNT,
			display: 'Widgets',
			disableSorting: true,
			width: 1,
		},
	];

	constructor(
		private dialogRef: MatDialogRef<SelectDashboardDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { jobKey: string },
		private store: Store
	) {
		super();
	}

	ngOnInit() {
		this.jobKey = this.data?.jobKey;

		this.isLoaded$.pipe(takeUntil(this.destroy)).subscribe((isLoaded) => {
			if (!isLoaded) {
				this.store.dispatch(new DashboardActions.GetAll({ jobKey: this.jobKey, showSpinner: true, showToast: true }));
			}
		});

		this.dashboards$.pipe(takeUntil(this.destroy)).subscribe((dashboards) => {
			if (dashboards) {
				let userDashboards = UtilityHelper.deepCopy(dashboards);
				this.userDashboards = [...userDashboards];
			}
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	rowClicked(userDashboard: DashboardDto) {
		this.selectedUserDashboard = userDashboard;
	}

	rowSelected() {
		this.dialogRef.close(this.selectedUserDashboard);
	}
}
